/* MT sticky product bar (product template) */
(function () {
  'use strict';

  function bindDirectionFill(buttons, fillSelector) {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    buttons.forEach(function (btn) {
      var fill = btn.querySelector(fillSelector);
      if (!fill || btn.disabled) return;

      var side = function (e) {
        var rect = btn.getBoundingClientRect();
        return e.clientX < rect.left + rect.width / 2 ? 'left center' : 'right center';
      };

      btn.addEventListener('pointerenter', function (e) {
        if (reduceMotion) {
          btn.classList.add('is-fill');
          return;
        }
        fill.style.transition = 'none';
        fill.style.transformOrigin = side(e);
        void fill.offsetWidth;
        fill.style.transition = 'transform 0.38s cubic-bezier(0.4, 0, 0.2, 1)';
        fill.style.transform = 'scaleX(1)';
        btn.classList.add('is-fill');
      });

      btn.addEventListener('pointerleave', function (e) {
        if (reduceMotion) {
          btn.classList.remove('is-fill');
          return;
        }
        fill.style.transformOrigin = side(e);
        fill.style.transform = 'scaleX(0)';
        btn.classList.remove('is-fill');
      });
    });
  }

  function bindClipFill(buttons, fillSelector) {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var hiddenLeft = 'inset(0 100% 0 0 round 999px)';
    var hiddenRight = 'inset(0 0 0 100% round 999px)';
    var shown = 'inset(0 0 0 0 round 999px)';

    buttons.forEach(function (btn) {
      var fill = btn.querySelector(fillSelector);
      if (!fill || btn.disabled) return;

      var hiddenFor = function (e) {
        var rect = btn.getBoundingClientRect();
        return e.clientX < rect.left + rect.width / 2 ? hiddenLeft : hiddenRight;
      };

      var settle = function () {
        btn.classList.add('is-fill-settled');
      };

      var unsettle = function () {
        btn.classList.remove('is-fill-settled');
      };

      fill.addEventListener('transitionend', function (e) {
        if (e.propertyName !== 'clip-path') return;
        if (btn.classList.contains('is-fill')) settle();
        else unsettle();
      });

      btn.addEventListener('pointerenter', function (e) {
        unsettle();
        if (reduceMotion) {
          fill.style.clipPath = shown;
          btn.classList.add('is-fill');
          settle();
          return;
        }
        fill.style.transition = 'none';
        fill.style.clipPath = hiddenFor(e);
        void fill.offsetWidth;
        fill.style.transition = 'clip-path 0.38s cubic-bezier(0.4, 0, 0.2, 1)';
        fill.style.clipPath = shown;
        btn.classList.add('is-fill');
      });

      btn.addEventListener('pointerleave', function (e) {
        unsettle();
        if (reduceMotion) {
          fill.style.clipPath = hiddenLeft;
          btn.classList.remove('is-fill');
          return;
        }
        fill.style.transition = 'clip-path 0.38s cubic-bezier(0.4, 0, 0.2, 1)';
        fill.style.clipPath = hiddenFor(e);
        btn.classList.remove('is-fill');
      });
    });
  }

  function getMoneyConfig(root) {
    if (!root) return {};
    if (!root._moneyConfig) {
      var el = root.querySelector('[data-sb-money-config]');
      if (el) {
        try {
          root._moneyConfig = JSON.parse(el.textContent);
        } catch (e) {
          root._moneyConfig = {};
        }
      } else {
        root._moneyConfig = {};
      }
    }
    return root._moneyConfig;
  }

  function getActiveCurrency(root) {
    var config = getMoneyConfig(root);
    if (window.Shopify && Shopify.currency && Shopify.currency.active) {
      return Shopify.currency.active;
    }
    return config.currency || 'USD';
  }

  function getCurrencyRate(root) {
    var config = getMoneyConfig(root);
    var shopCurrency = config.shopCurrency;
    var active = getActiveCurrency(root);
    if (shopCurrency && active && shopCurrency !== active) {
      if (window.Shopify && Shopify.currency && Shopify.currency.rate) {
        var rate = parseFloat(Shopify.currency.rate);
        if (!isNaN(rate) && rate > 0) return rate;
      }
    }
    return 1;
  }

  function formatWithShopify(cents, format) {
    if (!format || !window.Shopify || !Shopify.formatMoney) return '';
    var formatted = Shopify.formatMoney(cents, format);
    return formatted.replace(/(\.|,)00(?!\d)/, '');
  }

  function formatMoney(cents, root) {
    var config = getMoneyConfig(root);
    var rate = getCurrencyRate(root);
    var adjustedCents = Math.round(Number(cents) * rate);
    var formatted = formatWithShopify(adjustedCents, config.moneyFormat);
    if (formatted) return formatted;

    var currency = getActiveCurrency(root);
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 2
      }).format(adjustedCents / 100);
    } catch (e) {}

    var symbol = config.currencySymbol || '';
    return symbol + (adjustedCents / 100).toFixed(2);
  }

  class MtStickyBar extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;

      this.syncMain = this.dataset.syncMain === 'true';
      this.alwaysVisible = this.hasAttribute('data-always-visible');
      this.atcDefault = this.dataset.atcLabel || 'Add to Cart';
      this.soldOutLabel = this.dataset.soldOutLabel || 'Sold out';

      this.variantInput = this.querySelector('[data-sticky-variant-id]');
      this.priceEl = this.querySelector('[data-sticky-price]');
      this.compareEl = this.querySelector('[data-sticky-compare]');
      this.atcBtn = this.querySelector('[data-sticky-atc]');
      this.atcText = this.querySelector('[data-sticky-atc-text]');
      this.buyNowBtn = this.querySelector('[data-sticky-buy-now]');
      this.swatches = this.querySelector('[data-sticky-swatches]');

      var variantsNode = this.querySelector('[data-sticky-variants]');
      this.variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];

      this.mainProductForm = document.querySelector('mt-product product-form');
      this.mainSelects = this.mainProductForm ? this.mainProductForm.querySelector('variant-selects') : null;
      this.mainVariantInput = this.mainProductForm
        ? (this.mainProductForm.querySelector('.mt-product__block--buy-buttons input[name="id"]')
          || this.mainProductForm.querySelector('input[name="id"][data-variant-id]'))
        : null;
      this._syncing = false;

      this.addEventListener('change', (e) => {
        if (e.target.matches('input[type="radio"]')) this.onStickyVariantChange();
      });

      if (this.atcBtn) this.atcBtn.addEventListener('click', () => this.addToCart());
      if (this.buyNowBtn) this.buyNowBtn.addEventListener('click', () => this.buyNow());

      if (this.syncMain && this.mainSelects) {
        this.mainSelects.addEventListener('change', () => this.syncFromMain());
      }

      bindDirectionFill(this.querySelectorAll('.mt-sticky-bar__atc'), '.mt-sticky-bar__atc-fill');
      bindClipFill(this.querySelectorAll('.mt-sticky-bar__buy-now'), '.mt-sticky-bar__buy-now-fill');

      this.setupVisibility();
      this.syncFromMain();
      this.watchCurrencyChanges();
    }

    watchCurrencyChanges() {
      var self = this;
      var config = getMoneyConfig(this);
      if (!config.shopCurrency || config.shopCurrency === getActiveCurrency(this)) return;

      var attempts = 0;
      (function watch() {
        if (!self.isConnected || attempts >= 15) return;
        attempts += 1;
        var variant = self.findVariantById(self.variantInput && self.variantInput.value);
        if (variant) self.setVariant(variant);
        if (getCurrencyRate(self) === 1) {
          setTimeout(watch, 100);
        }
      })();
    }

    disconnectedCallback() {
      if (this._io) this._io.disconnect();
      if (this._onResizeVisibility) {
        window.removeEventListener('resize', this._onResizeVisibility);
      }
      document.documentElement.classList.remove('has-sticky-bar');
    }

    isMobile() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    setupVisibility() {
      if (this.alwaysVisible) {
        this.setVisible(true);
        return;
      }

      this._onResizeVisibility = () => this.applyVisibilityMode();
      window.addEventListener('resize', this._onResizeVisibility);
      this.applyVisibilityMode();
    }

    applyVisibilityMode() {
      if (this.isMobile()) {
        if (this._io) {
          this._io.disconnect();
          this._io = null;
        }
        this.setVisible(true);
        return;
      }

      var target =
        document.querySelector('mt-product.mt-product') ||
        document.querySelector('mt-product') ||
        document.querySelector('.section-mt-product mt-product');

      if (!target) {
        this.setVisible(false);
        return;
      }

      if (this._io) return;

      this.setVisible(false);

      this._io = new IntersectionObserver(
        (entries) => {
          if (this.isMobile()) {
            this.setVisible(true);
            return;
          }
          this.setVisible(!entries[0].isIntersecting);
        },
        { threshold: 0 }
      );
      this._io.observe(target);
    }

    setVisible(on) {
      this.classList.toggle('is-visible', on);
      document.documentElement.classList.toggle('has-sticky-bar', on);
    }

    getSelectedOptionValues() {
      if (this.syncMain && this.mainSelects) {
        return Array.from(this.mainSelects.querySelectorAll('input[type="radio"]:checked')).map(function (i) {
          return i.value;
        });
      }

      var current = this.findVariantById(this.variantInput.value);
      var vals = current && current.options ? current.options.slice() : [];

      this.querySelectorAll('input[type="radio"]:checked').forEach(function (input) {
        var pos = parseInt(input.getAttribute('data-option-position'), 10);
        if (pos > 0) vals[pos - 1] = input.value;
      });

      return vals;
    }

    escapeValue(value) {
      if (window.CSS && typeof CSS.escape === 'function') return CSS.escape(value);
      return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
    }

    findVariantByValues(vals) {
      return this.variants.find(function (v) {
        return JSON.stringify(v.options) === JSON.stringify(vals);
      });
    }

    findVariantById(id) {
      return this.variants.find(function (v) {
        return String(v.id) === String(id);
      });
    }

    setVariant(variant) {
      if (!variant) return;
      if (this.variantInput) this.variantInput.value = variant.id;

      if (this.priceEl && typeof variant.price === 'number') {
        this.priceEl.textContent = formatMoney(variant.price, this);
      }

      if (this.compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          this.compareEl.textContent = formatMoney(variant.compare_at_price, this);
          this.compareEl.hidden = false;
        } else {
          this.compareEl.hidden = true;
        }
      }

      var available = !!variant.available;
      if (this.atcBtn) this.atcBtn.disabled = !available;
      if (this.buyNowBtn) this.buyNowBtn.disabled = !available;
      if (this.atcText) {
        this.atcText.textContent = available ? this.atcDefault : this.soldOutLabel;
      }
    }

    syncFromMain() {
      if (!this.syncMain || this._syncing) return;
      this._syncing = true;

      var variantId = this.mainVariantInput ? this.mainVariantInput.value : null;
      if (variantId) {
        var variant = this.findVariantById(variantId);
        if (variant) {
          this.updateStickyRadiosFromVariant(variant);
          this.setVariant(variant);
        }
      }

      this._syncing = false;
    }

    updateStickyRadiosFromVariant(variant) {
      if (!variant || !variant.options) return;
      variant.options.forEach(function (value, index) {
        var pos = index + 1;
        var input = this.querySelector(
          'input[type="radio"][data-option-position="' + pos + '"][value="' + this.escapeValue(value) + '"]'
        );
        if (input && !input.checked) input.checked = true;
      }, this);
    }

    onStickyVariantChange() {
      if (this._syncing) return;

      if (this.syncMain && this.mainSelects) {
        this._syncing = true;
        this.querySelectorAll('input[type="radio"]:checked').forEach(function (input) {
          var pos = input.getAttribute('data-option-position');
          var mainInput = this.mainSelects.querySelector(
            'input[name="option' + pos + '"][value="' + this.escapeValue(input.value) + '"]'
          );
          if (mainInput && !mainInput.checked) mainInput.checked = true;
        }, this);
        this.mainSelects.dispatchEvent(new Event('change', { bubbles: true }));
        this._syncing = false;
        this.syncFromMain();
        return;
      }

      var match = this.findVariantByValues(this.getSelectedOptionValues());
      if (match) this.setVariant(match);
    }

    getLineItems() {
      if (this.syncMain && this.mainProductForm) {
        var items = [this.mainProductForm.getMainLineItem()];
        if (typeof this.mainProductForm.getRecItems === 'function') {
          items = items.concat(this.mainProductForm.getRecItems());
        }
        return items;
      }

      return [{
        id: this.variantInput ? this.variantInput.value : null,
        quantity: 1
      }];
    }

    buildBuyNowPayload() {
      var items = this.getLineItems().filter(function (item) { return item && item.id; });
      if (!items.length) return null;

      var payload = { items: items };
      if (window.MtBundleCart && typeof window.MtBundleCart.expandAddPayload === 'function') {
        window.MtBundleCart.collectBundleMap();
        payload = window.MtBundleCart.expandAddPayload(payload);
      }
      return payload;
    }

    async addToCart() {
      if (!this.atcBtn || this.atcBtn.disabled) return;
      var items = this.getLineItems().filter(function (item) { return item && item.id; });
      if (!items.length) return;

      this.atcBtn.disabled = true;
      try {
        var payload = items.length === 1 ? items[0] : { items: items };
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
        var data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Error');
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'sticky-bar', cartAdd: data } }));
        if (window.MtAtcToast) window.MtAtcToast.show(this.atcBtn, data);
      } catch (err) {
        window.alert(err.message);
      } finally {
        var variant = this.findVariantById(this.variantInput.value);
        this.atcBtn.disabled = !(variant && variant.available);
      }
    }

    async buyNow() {
      if (!this.buyNowBtn || this.buyNowBtn.disabled) return;
      var payload = this.buildBuyNowPayload();
      if (!payload) return;

      this.buyNowBtn.disabled = true;
      try {
        await fetch('/cart/clear.js', { method: 'POST', credentials: 'same-origin' });
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
        var data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Error');
        window.location.href = '/checkout';
      } catch (err) {
        window.alert(err.message);
        var variant = this.findVariantById(this.variantInput.value);
        this.buyNowBtn.disabled = !(variant && variant.available);
      }
    }
  }

  if (!customElements.get('mt-sticky-bar')) {
    customElements.define('mt-sticky-bar', MtStickyBar);
  }
})();
